import { z } from "zod";
import { FaqArticleDbParser, FaqCollectionDbParser } from "./faq-db-parser";

export const faqThemeBodySchema = z.object({
  enabled: z.boolean(),
  homeBackgroundImageUrl: z.string().nullish(),
  overlayColor: z.string(),
  overlayOpacity: z.number(),
  headlineText: z.string(),
  headlineTextColor: z.string(),
  pageBackgroundColor: z.string(),
  displayCollectionIcon: z.boolean(),
  displayCollectionSubtext: z.boolean(),
  collectionBackgroundColor: z.string(),
  collectionBorderColor: z.string(),
  collectionCornerRadius: z.number(),
});

export const faqCollectionBodySchema = FaqCollectionDbParser.extend({
  _id: z.string(),
  team: z.string(),
  articles: z.array(z.string()),
});

export const faqArticleBodySchema = FaqArticleDbParser.extend({
  _id: z.string(),
  team: z.string(),
  faqCollection: z.string(),
  lastEditedAt: z.date(),
});
